import { ui } from '../../styles/ui'

export const WINDOW_SECONDS_OPTIONS = [60, 3600, 86400, 2592000]
export const ENDPOINT_GROUP_OPTIONS = ['public_recognition', 'telegram_mini_app_recognition']
export const SUBJECT_TYPE_OPTIONS = ['global', 'anonymous_ip', 'user', 'mobile_device', 'external_identity']
export const POLICY_STATUS_OPTIONS = ['active', 'disabled', 'archived']
export const BUCKET_TYPE_OPTIONS = ['minute', 'hour', 'day', 'month']

export function shortValue(value, length = 10) {
  const text = String(value || '').trim()
  if (!text) return '-'
  return text.length > length ? `${text.slice(0, length)}...` : text
}

export function statusPillClass(status) {
  const normalized = String(status || '').trim().toLowerCase()
  if (normalized === 'active' || normalized === 'published' || normalized === 'enabled') return ui.badges.success
  if (normalized === 'blocked' || normalized === 'disabled' || normalized === 'archived' || normalized === 'revoked') return ui.badges.danger
  if (normalized === 'pending' || normalized === 'processing') return ui.badges.warning
  return ui.badges.neutral
}

export function formatSubjectDisplay(subjectType, subjectId) {
  const type = String(subjectType || '').trim()
  const id = String(subjectId || '').trim()
  if (type === 'global') return 'Global'
  if (!id) return type
  return `${type}: ${shortValue(id, 16)}`
}

export function formatUsageSummary(summary = {}) {
  return {
    requestCount: Number(summary.requestCount || 0),
    acceptedCount: Number(summary.acceptedCount || 0),
    rejectedCount: Number(summary.rejectedCount || 0),
    costUnits: Number(summary.costUnits || 0),
  }
}
